import {
  Box,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
} from '@dixa/lib-shared-habla';
import { useState } from 'react';

import { TimezoneSelector } from 'components/timezoneSelector';

type Props = {
  timezone: string;
  onClose: VoidFunction;
  onSubmit: (timzone: string) => void;
};

export const TimezoneModal = ({
  timezone: propTimezone,
  onClose,
  onSubmit,
}: Props): JSX.Element => {
  const [timezone, setTimezone] = useState<string>(propTimezone);

  return (
    <Modal isOpen onClose={onClose}>
      <Box width="600px">
        <ModalHead onClose={onClose} title="Edit timezone" />
        <ModalBody>
          <TimezoneSelector
            placeholder="Select the timezone for this schedule"
            required
            input={{
              name: 'timezone',
              onChange: (value) => value && setTimezone(value),
              value: timezone,
            }}
            noAlert
          />
        </ModalBody>
        <ModalFoot
          cancelOnClick={onClose}
          confirmProps={{ disabled: timezone === propTimezone }}
          confirmName="Update"
          confirmOnClick={() => {
            onSubmit(timezone);
            onClose();
          }}
        />
      </Box>
    </Modal>
  );
};
